export default {
  rooms: 'Oda:',
  area: 'Alan:',
  ai_predictions_title: '📊 Yapay zeka ile fiyat tahminleri',
  more: 'Daha fazla bilgi +',

  // 🏷 İşlem türü
  purpose: {
    sale: 'Satılık',
    rent: 'Kiralık',
    short_term: 'Kısa süreli kiralama'
  }
}
